import { render } from "./new-apple-aPlayer.vue?vue&type=template&id=285d7d80&scoped=true"
import script from "./new-apple-aPlayer.vue?vue&type=script&lang=js"
export * from "./new-apple-aPlayer.vue?vue&type=script&lang=js"

import "./new-apple-aPlayer.vue?vue&type=style&index=0&id=285d7d80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285d7d80"]])

export default __exports__